import './DeviceManagement.css';
import AdminPageLayout from '../../components/AdminPageLayout/AdminPageLayout';
import { ConfigProvider } from 'antd';
import { useLocation } from 'react-router-dom';

const DeviceManagement = () => {
  const location = useLocation();
  const isMobileView = location.pathname.split('/')[1] === 'mobile';

  return (
    <ConfigProvider
      theme={{
        components: {
          Layout: {
            headerBg: isMobileView && '#FFFFFF',
            footerBg: isMobileView && '#FFFFFF',
            bodyBg: isMobileView && '#FFFFFF',
            bodyColor: isMobileView && '#FFFFFF',
            headerColor: isMobileView && '#FFFFFF',
            footerColor: isMobileView && '#FFFFFF',
          },
        },
      }}
    >
      <AdminPageLayout
        rootPath="/device-management"
        className="device-management"
      />
    </ConfigProvider>
  );
};

export default DeviceManagement;
